import { createAsyncThunk } from "@reduxjs/toolkit";
import { login, changePassword, getAllAuthorities } from "@/api/modules/login";

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const loginAction = createAsyncThunk(
  "login",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await login(params);
    if (result.data) return result.data;
  });


// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const changePasswordAction = createAsyncThunk(
  "changePassword",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await changePassword(params);
    if (result.data) return result.data;
  });

// 获取所有权限
export const getAllAuthoritiesAction = createAsyncThunk(
  "getAllAuthorities",
  async (params: any) => {
    const result = await getAllAuthorities(params);
    if (result.data) return result.data
  })